import React from 'react';
import Hero from './Hero/Hero';
import Top from './Top/Top';
import Best from './Best/Best';
import Trend from './Trend/Trend'
import About from './About/About'

function Basketball() {
  return (
    <div>
        <Hero/>
        <Top/>
        <Best/>
        <Trend/>
        <About/>
    </div>
  )
}

export default Basketball